import React from "react";
import PropTypes from "prop-types";
import { ToastContainer } from "react-toastify";
import RequestsInbox, { requestsPayloadShape } from "./components/RequestsInbox";
import { staffingTabPathsShape } from "./components/StaffingTabs";

const StaffingRequestsApp = ({ tabPaths, requests, paths }) => (
  <>
    <div className="od-themed" style={{ padding: 24 }}>
      <RequestsInbox tabPaths={tabPaths} initialRequests={requests} paths={paths} />
    </div>
    <ToastContainer icon={false} />
  </>
);

StaffingRequestsApp.propTypes = {
  tabPaths: staffingTabPathsShape.isRequired,
  requests: requestsPayloadShape.isRequired,
  paths: PropTypes.shape({ requests: PropTypes.string.isRequired }).isRequired,
};

export default StaffingRequestsApp;
